const meta = {
  install: 'Install',
  'release-notes': 'Release notes',
};

export default meta;
